import { render, staticRenderFns } from "./menu-items.vue?vue&type=template&id=25e8175d&scoped=true"
import script from "./menu-items.vue?vue&type=script&lang=js"
export * from "./menu-items.vue?vue&type=script&lang=js"
import style0 from "./menu-items.vue?vue&type=style&index=0&id=25e8175d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8175d",
  null
  
)

export default component.exports